import { render, staticRenderFns } from "./SalaryInquiryForm.vue?vue&type=template&id=6b0da056&"
import script from "./SalaryInquiryForm.vue?vue&type=script&lang=js&"
export * from "./SalaryInquiryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports